<div class="matrix_layoutMain matrix_layoutUseMatrix container" v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12 matrix_layoutMatrixContainerColMain">
            <div class="matrix_productPartsMainContainer matrix_table">
                <appPreferredOptionsContainer></appPreferredOptionsContainer>
                <div class="matrix_layoutAdminPreferredSelectionActions">
                    <appApplyPreferredSelection></appApplyPreferredSelection>
                    <appResetSelectionButton></appResetSelectionButton>
                </div>
            </div>
        </div>
    </div>
</div>
